import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { ContactsService } from "src/app/pages/contacts/services/contacts.service";
import { ContactModel } from "../../../models/contacts.model";
import { EventService } from "src/app/core/services/event.service";
import { DevelopmentsService } from "../../../services/developments.services";
import { PermissionsService } from "src/app/core/services/permissions.service";

@Component({
  selector: "app-contacts-developments",
  templateUrl: "./contacts.component.html",
  styleUrls: ["./contacts.component.scss"],
})
export class ContactsDevelopmentsComponent implements OnInit, OnDestroy {
  @Input() propertyCostumersContactsData: any;
  @Input() propertyOwnersContactsData: any;
  @Input() propertyId: any;
  @Input() property: any;

  propertyContactsData: any;
  contactsCostumersDelete!: ContactModel[];
  contactsOwnersDelete!: ContactModel[];
  nabTabActive = 1;
  hideElement: boolean = true;
  countCheckSelected = 0;
  private currentNavTabSubject!: BehaviorSubject<number>;
  contactsData!: any;
  subscription: Subscription = new Subscription();
  textAddContact = "t-add-costumer";
  loginUser!: {
    id?: string;
    role?: { id?: string; name?: string };
    stores?: any[];
    associatedUsers?: any;
  };

  constructor(
    private contactsService: ContactsService,
    private eventService: EventService,
    private propertiesService: DevelopmentsService,
    public permissionsService: PermissionsService
  ) {
    this.currentNavTabSubject = new BehaviorSubject<number>(this.nabTabActive);
  }

  ngOnInit(): void {
    const { id, role, stores, associatedUsers } = this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores, associatedUsers };

    this.contactsData = {
      data: {
        costumers: { ...this.propertyCostumersContactsData.data },
        owners: { ...this.propertyOwnersContactsData.data },
        contactsCostumersDelete: this.propertyCostumersContactsData.dataDelete,
        contactsOwnersDelete: this.propertyOwnersContactsData.dataDelete,
        tab: this.nabTabActive,
        propertyId: this.propertyId,
      },
    };

    const subscriptionCountCheckSelected = this.eventService.subscribe(
      "count-check -selected-contacts-dev",
      (data) => {
        this.countCheckSelected = data;
      }
    );

    this.subscription.add(subscriptionCountCheckSelected);

    this.loadData(this.nabTabActive);
    const subscriptionTab = this.currentNavTabSubject
      .asObservable()
      .subscribe((nabTab) => {
        this.loadData(nabTab);
        this.hideElement = false;
      });
    this.subscription.add(subscriptionTab);

    const subscriptionSubmitted = this.eventService.subscribe(
      "get-data-tab-contacts-dev",
      () => {
        if (this.propertyCostumersContactsData?.data) {
          this.propertyCostumersContactsData.data =
            this.contactsData.data.costumers;
          this.propertyCostumersContactsData.dataDelete =
            this.contactsData.data.contactsCostumersDelete;
        }
        if (this.propertyOwnersContactsData?.data) {
          this.propertyOwnersContactsData.data = this.contactsData.data.owners;
          this.propertyOwnersContactsData.dataDelete =
            this.contactsData.data.contactsOwnersDelete;
        }
      }
    );

    this.subscription.add(subscriptionSubmitted);
  }

  activeIdChangeNabTab() {
    this.currentNavTabSubject.next(this.nabTabActive);
  }

  loadData(nabTab: number) {
    if (nabTab == 2) {
      this.textAddContact = "t-add-costumer";
    } else if (nabTab == 1) {
      this.textAddContact = "t-add-owner";
    }
    this.contactsData.data.tab = nabTab;
  }

  openModal() {
    const btnAdd = document.getElementById("btn-add-contact-property");
    btnAdd?.click();
  }

  deleteMultiple() {
    const btnDelete = document.getElementById("btn-delete-contact-property");
    btnDelete?.click();
  }

  ngOnDestroy(): void {
    if (this.propertyCostumersContactsData?.data) {
      this.propertyCostumersContactsData.data =
        this.contactsData.data.costumers;
      this.propertyCostumersContactsData.dataDelete =
        this.contactsData.data.contactsCostumersDelete;
    }
    if (this.propertyOwnersContactsData?.data) {
      this.propertyOwnersContactsData.data = this.contactsData.data.owners;
      this.propertyOwnersContactsData.dataDelete =
        this.contactsData.data.contactsOwnersDelete;
    }
    this.subscription.unsubscribe();
  }
}
